import { getLangFromLocale } from "@/apiUtils/commonUtils";
import { cookieKeys } from "@/apiUtils/constants";
import { getCookieClient } from "@/apiUtils/cookieClientUtils";
import HeartIcon from "@/assets/icons/heartIcon.svg?react";
import HeartFilledIcon from "@/assets/icons/heartIconFilled.svg?react";
import { cn } from "@/lib/tailwind";
import { useParams } from "next/navigation";

interface IProps {
  isWishlisted: boolean;
  onAddToWishList: (e: React.MouseEvent) => Promise<void> | void;
  onCart?: boolean;
}

const AddToWishlist = ({
  onAddToWishList: handleWishList,
  isWishlisted,
  onCart = false,
}: IProps) => {
  const mobileView = getCookieClient(cookieKeys.PLP_MOBILE_VIEW);

  const { locale } = useParams();
  const lang = getLangFromLocale(locale as string) as "en" | "ar";

  const translations = {
    en: {
      addToWishlist: "Add to Wishlist",
      removeFromWishlist: "Remove from Wishlist",
    },
    ar: {
      addToWishlist: "إضافة إلى قائمة المفضلة",
      removeFromWishlist: "إزالة من قائمة المفضلة",
    },
  };

  return (
    <div
      className={cn(
        "flex h-5 w-5 cursor-pointer items-center justify-center bg-white shadow-sm md:h-7 md:w-7",
        mobileView === "Column" ? "h-7 w-7" : "h-5 w-5",
        onCart && "rounded-full",
      )}
    >
      <span
        title={
          isWishlisted ? translations[lang]?.addToWishlist : translations[lang]?.removeFromWishlist
        }
      >
        {isWishlisted ? (
          <HeartFilledIcon
            width={14}
            height={14}
            // viewBox="0 0 25 25"
            onClick={handleWishList}
            className={cn(
              "h-[13px] w-4 cursor-pointer md:h-[15px] md:w-[18px]",
              mobileView === "Column" ? "h-[15px] w-[18px]" : "h-[13px] w-4",
            )}
            // @ts-ignore
            title={
              isWishlisted
                ? translations[lang]?.addToWishlist
                : translations[lang]?.removeFromWishlist
            }
          />
        ) : (
          <HeartIcon
            width={14}
            height={14}
            // viewBox="0 0 25 25"
            onClick={handleWishList}
            className={cn(
              "h-[13px] w-4 cursor-pointer md:h-[15px] md:w-[18px]",
              mobileView === "Column" ? "h-[15px] w-[18px]" : "h-[13px] w-4",
            )}
            // @ts-ignore
            title={
              isWishlisted
                ? translations[lang]?.addToWishlist
                : translations[lang]?.removeFromWishlist
            }
          />
        )}
      </span>
    </div>
  );
};

export default AddToWishlist;
